import { MenuItem, TextField } from '@mui/material';
import { HSTRoles } from './HSTRoles';
import React from 'react';

interface HSTSelectRole {
    selectedRole: string;
    onChange: (role: string) => void;
}

function HSTSelectRole({ selectedRole, onChange }: HSTSelectRole) {
   
    const handleRoleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        onChange(event.target.value);
    };

    return (
        <TextField
            select
            value={selectedRole}
            onChange={handleRoleChange}
            fullWidth
            sx={{ margin: 1, width: '100%' }}
            size="small"
            variant="outlined"        >
            {Object.entries(HSTRoles).map(([key, role]) => (
                <MenuItem key={key} value={key}>
                    {role.name}
                </MenuItem>
            ))}
        </TextField>
    );
}

export { HSTSelectRole };
